export default __webpack_public_path__ + "static/media/twilio.bae27ecf.svg";